import { db } from "../services/firebase";

function downloadObjectAsJson(exportObj, exportName) {
  var dataStr =
    "data:text/json;charset=utf-8," +
    encodeURIComponent(JSON.stringify(exportObj, null, 4));
  var downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", exportName + ".json");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}
export async function downloadMessages(workshops, onComplete) {
  try {
    const allWorkshopsData = await Promise.all(
      workshops.map(async (currentWorkshop) => {
        const teamsSnapshot = await db
          .collection("teams")
          .where("workshopId", "==", currentWorkshop.id)
          .get();

        const teams = await Promise.all(
          teamsSnapshot.docs.map(async (teamDoc) => {
            const boardsSnapshot = await db
              .collection("boards")
              .where("teamId", "==", teamDoc.id)
              .get();

            const boards = await Promise.all(
              boardsSnapshot.docs.map(async (boardDoc) => {
                const messages = await Promise.all(
                  boardDoc.data().messages.map(async (messageId) => {
                    const messageDoc = await db
                      .collection("boardMessages")
                      .doc(messageId)
                      .get();

                    if (!messageDoc.exists) return null;

                    const userDoc = await db
                      .collection("users")
                      .doc(messageDoc.data().uid)
                      .get();

                    if (!userDoc.exists) return null;

                    return {
                      content: messageDoc.data().content,
                      tags: messageDoc.data().tags,
                      categories: messageDoc.data().categories,
                      author: userDoc.data().displayName,
                    };
                  })
                );

                // Filtrer les messages nuls (erreurs ou non existants)
                return {
                  board: boardDoc.data().name,
                  messages: messages.filter(Boolean),
                };
              })
            );

            return { team: teamDoc.data().name, boards };
          })
        );

        return {
          workshop: currentWorkshop.name,
          teams,
        };
      })
    );

    // Téléchargement des données sous forme de fichier JSON
    downloadObjectAsJson(allWorkshopsData, "Workshops Data");
  } catch (error) {
    console.error("Error downloading messages:", error);
  } finally {
    // Appel de la fonction `onComplete` même en cas d'erreur
    onComplete();
  }
}
